<template>
  <div class="page-question" v-show="isShow && isMounted">
    <div class="left-right-content clearfix">
      <el-breadcrumb class="add-breadcrumb" separator="/">
        <el-breadcrumb-item >
          <a :href="baseUrl+'/nAnimateMake?plate=3'" >动画制作</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item >
          <a :href="baseUrl+'/rquestions?plate=3'" >问答</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>悬赏问答</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="c-left">
        <ul class="top-select-tit clearfix">
          <a tag="li" :href="baseUrl+'/gquestions?plate=3'">普通问答</a>
          <a tag="li" :href="baseUrl+'/rquestions?plate=3'" class="active">悬赏问答</a>
        </ul>
        <div class="detail-view">
          <div class="add-guanzhu" v-if="!isExistAttention">
            <span @click="doExistAttention"><i class="el-icon-plus"></i> 关注</span>
            <div class="focus-tips" v-if="showNotice">
              关注问题后，当有新回答添加时会第一时间通知你！
              <i class="close-btn el-icon-close" @click="closeNotice"></i>
            </div>
          </div>
          <div class="add-guanzhu" v-else>
            已关注
          </div>
          <div class="tit">{{questionDetail.title}}</div>
          <div class="info-date clearfix">
            <span class="user-avatar" :style="{'background-image': 'url(' + `http://iss.21teacher.com/avatar/125/${questionDetail.userId}/20.jpg` + ')'}"></span>
            <span class="user-name">{{questionDetail.userName}}</span>
            <span class="date">{{questionDetail.publishDate | formatTime}}</span>
          </div>
          <overflow-words :words="questionDetail.content" />
        </div>
        <!-- 评论 -->
        <que-pinglun ref="pinglun" v-if="isReload && isMounted" :answerTo = "objId" :questionObj="question" :aId="aId"/>
        <!-- 评论 -->
      </div>
      <div class="c-right">
        <div class="one-item question-info">
          <div class="deta-info">
            <div class="top-count" v-if="answerNum > 0">
              <span v-show="attentionCount >0 ">已有<span>{{attentionCount}}</span>人关注</span>
              <span v-if="answerNum > 0"><span>{{answerNum}}</span>人回答</span><span v-else>暂无人回答</span>
              <span v-show="questionDetail.supportcnt >0 "><span>{{questionDetail.supportcnt}}</span>人点赞</span>
            </div>
            <div class="btns">
              <el-button @click="yaoqingEvent">邀请回答</el-button>
              <el-button @click="tianjiaEvent" type="primary" class="tj">添加回答</el-button>
            </div>
          </div>
          <!-- 没有答主 -->
          <div class="no-dazhu" v-if="questionDetail.accept == 0">
            <div class="tit">
              最佳答主
              <div class="wanfa" @click="wanfaEvent">
                <span class="ico">?</span>
                <span class="wor">玩法</span>
              </div>
            </div>
            <div class="xs-dz-info clearfix">
              <img class="img-l" :src="require('@/assets/images/xs_img_money.png')" alt="">
              <div class="x-info">
                悬赏<br>
                ￥{{questionDetail.experience}}
              </div>
            </div>
            <div class="tips">该问题未评选出最佳回答，快来发布你的意见吧！</div>
          </div>
          <!-- 已有答主 -->
          <div class="detail-userinfo" v-else>
            <div class="tit">
              最佳答主
              <div class="wanfa" @click="wanfaEvent">
                <span class="ico">?</span>
                <span class="wor">玩法</span>
              </div>
            </div>
            <router-link :to="{path:'/home', query: {userId:userInfo.userId}}" class="avatar-f"><img :src="userInfo.imgUrl"  alt=""></router-link>
            <div class="user-name"><router-link to="/home">{{userInfo.userName}}</router-link></div>
            <div class="chenghao">{{userInfo.signature}}</div>
            <div class="qianming">{{userInfo.introduction}}</div>
            <div class="btns" v-if="isLogin && userInfo.userId != loginUserId">
              <el-button class="btn wgz-btn" type="danger" v-if="userInfo.followStatus==0"  @click="doFollow(userInfo.userId)"><i class="el-icon-plus"></i> 关注</el-button>
              <el-button class="btn" v-else-if="userInfo.followStatus==1" @click="undoFollower(userInfo.userId)">已关注</el-button>
              <el-button class="btn" v-else-if="userInfo.followStatus==2" @click="undoFollower(userInfo.userId)">互相关注</el-button>

              <el-button class="btn wgz-btn" v-if="friendStatus == 4"  @click="addFriend()"><i class="el-icon-plus"></i> 加好友</el-button>
              <!--<el-button class="btn" @click="toChart(userInfo.userId)" v-else-if="friendStatus == 2">发消息</el-button>-->
              <el-button class="btn" v-else-if="friendStatus == 1" style="cursor:auto">请求中</el-button>
            </div>
            <ul class="much-list four clearfix">
              <li>
                <span class="tit">作品</span>
                <span class="count">{{userInfo.productionsCount}}</span>
              </li>
              <li>
                <span class="tit">文章</span>
                <span class="count">{{userInfo.archivesCount}}</span>
              </li>
              <li>
                <span class="tit">回答</span>
                <span class="count">{{userInfo.answersCount}}</span>
              </li>
              <li>
                <span class="tit">粉丝</span>
                <span class="count">{{userInfo.followersCount}}</span>
              </li>
            </ul>
            <div class="best-ans" v-if="userInfo.isReceive == 0">恭喜<span>{{userInfo.userName}}</span>获得最佳答主，获得{{question.experience}}元悬赏奖励，请及时<span class="lq" @click="lingqu" v-if="userInfo.userId == loginUserId">领取奖励。</span><span  v-else>领取奖励。</span></div>
            <div class="best-ans" v-else>恭喜<span>{{userInfo.userName}}</span>获得最佳答主，所得{{question.experience}}元悬赏奖励已送出~~~</div>
          </div>
        </div>

        <div class="one-item">
          <div class="one-title">
            相关问答
            <i class="el-icon-refresh-right shuaxin" @click="about"></i>
          </div>
          <ul class="articles-list">
            <li v-for="(item,index) in aboutList" :key="index">
              <div class="art-tit">
                <router-link :to="'/quedetail?id='+item.id+'&plate='+item.belongSection+''" target="_blank">{{item.title}}</router-link>
              </div>
              <span class="much-count clearfix">
                <span class="much">访问量<span class="num">{{item.hits}}</span></span>
                <span class="xs-mu">悬赏<span class="num">￥{{item.experience}}</span></span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="lingqu-jiangli" v-if="showLingqu">
        <div class="wrap">
          <i class="close-icon el-icon-circle-close" @click="closeLingqu"></i>
          <p class="words">恭喜您获得{{question.experience}}元悬赏奖励</p>
          <p class="money">￥{{question.experience}}</p>
          <a class="chakan" href="http://i.renrendonghua.com/macc/info" target="_blank">马上查看</a>
<!--          <router-link class="chakan" to="http://i.renrendonghua.com/macc/info">马上查看</router-link>-->
        </div>
      </div>
    </transition>
    <!--    邀请弹窗-->
    <el-dialog
            top="56px"
            :visible.sync="yaoqing"
            :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
    >
      <div class="yaoqing-friends-answer">
        <div class="inv-peo" v-if="yaoqingNum === 1">已邀请 {{shareCommendList.length}}/5</div>
        <ul class="select-tit">
          <li :class="yaoqingNum === 0 ? 'active' : ''" @click="yaoqingSelect(0)">好友</li>
          <li :class="yaoqingNum === 1 ? 'active' : ''" @click="yaoqingSelect(1)">推荐</li>
        </ul>
        <div class="friends-list" ref="userList" v-if="yaoqingNum == 0">

          <div class="fri-item clearfix" v-for="(item,index) in friendList" :key="index" >
            <div class="infos clearfix">
              <div class="avatar" :style="{'background-image': 'url(' + `http://iss.21teacher.com/avatar/125/${item.userInfo.userId}/20.jpg` + ')'}"></div>
              <div class="name-deng">
                <div class="u-name clearfix">
                  <div class="nc-name">{{item.userInfo.userName}}</div>
                  <div class="new-tchh clearfix" v-if="item.userInfo.userRankName">
                    <i class="icon zs"></i>
                    <!-- <i class="icon yx"></i> -->
                    <!-- <i class="icon hy"></i> -->
                    <span class="zuoz">{{item.userInfo.userRankName.split(",")[1]}}</span>
                    <span class="shu">|</span>
                    <span class="liny">{{item.userInfo.userRankName.split(",")[0]}}</span>
                  </div>
                </div>
                <div class="qianm">
                  {{userInfo.introduction}}
                </div>
              </div>
            </div>
            <el-button class="rig-btn" v-if="shareFriendList.indexOf(item.userInfo.userId) >-1">已邀请</el-button>
            <el-button class="rig-btn" v-else type="danger" @click="doShare(1,item.userInfo.userId,question.belongSection)">邀 请</el-button>
          </div>



          <div class="pagintion-f">
            <el-pagination
                    background
                    @current-change="friendList"
                    layout="prev, pager, next,jumper"
                    :current-page="friend.pageIndex"
                    :page-size="friend.pageSize"
                    :hide-on-single-page="true"
                    :total="friendTotal">
            </el-pagination>
          </div>
        </div>


        <div class="friends-list" ref="userList" v-if="yaoqingNum == 1">

          <div class="fri-item clearfix" v-for="(userInfo,index) in recommendList" :key="index" >
            <div class="infos clearfix">
              <div class="avatar" :style="{'background-image': 'url(' + `http://iss.21teacher.com/avatar/125/${userInfo.userId}/20.jpg` + ')'}"></div>
              <div class="name-deng">
                <div class="u-name clearfix">
                  <div class="nc-name">{{userInfo.userName}}</div>
                  <div class="new-tchh clearfix" v-if="userInfo.userRankName">
                    <i class="icon zs"></i>
                    <!-- <i class="icon yx"></i> -->
                    <!-- <i class="icon hy"></i> -->
                    <span class="zuoz">{{userInfo.userRankName.split(",")[1]}}</span>
                    <span class="shu">|</span>
                    <span class="liny">{{userInfo.userRankName.split(",")[0]}}</span>
                  </div>
                </div>
                <div class="qianm">
                  {{userInfo.introduction}}
                </div>
              </div>
            </div>

            <el-button class="rig-btn" v-if="shareCommendList.indexOf(userInfo.id) >-1" >已邀请</el-button>
            <el-button class="rig-btn" v-else type="danger" @click="doShare(2,userInfo.id,question.belongSection)">邀 请</el-button>
          </div>



          <div class="pagintion-f">
            <el-pagination
                    background
                    @current-change="searchRecommend"
                    layout="prev, pager, next,jumper"
                    :current-page="recommendParam.pageIndex"
                    :page-size="recommendParam.pageSize"
                    :hide-on-single-page="true"
                    :total="recommendTotal">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>


    <el-dialog
      title="悬赏规则"
      top="65px"
      :visible.sync="dialogVisible"
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
      center
    >
      <wanfa  v-if="isReloadWanfa"  :likeCount="likeCount" :disLikeCount="disLikeCount" :disLikeFlag="disLikeFlag" :likeFlag="likeFlag" />
    </el-dialog>
    <transition name="slide-title">
      <div class="fixed-title" v-if="showFixedTitle">
        <div class="cont">
          <span class="copy-title" @click="scollToTop">{{question.title}}</span>
          <div class="btns">
            <el-button @click="yaoqingEvent">邀请回答</el-button>
            <el-button @click="tianjiaEvent" type="danger" class="tj">添加回答</el-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script type="text/ecmascript-6">
import detailMixin from './detailMixin.js'
import wanfa from './wanfa'
import overflowWords from '../pub/overflow'

import questionApi from "@/api/question";
import answerApi from "@/api/answer";
import homeApi from '@/api/home'
import userInfoApi from "@/api/userInfo";
import shareApi from "@/api/share";
import apiService from '@/api/index'
import contentattentionApi  from "@/api/contentattention";

import updateTdk from "@/utils/tdk";
import {mapState} from "vuex";

export default {
  mixins: [detailMixin],
  components: {
    wanfa,overflowWords
  },
  data () {
    return {
      baseUrl:process.env.config.RRDH_HOST,
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      question:{},
      userInfo:{},
      friendStatus:-1,

      objId:0,
      isReload: false,
      isShow:false,

      loginUserId:0,
      isLogin:false,

      showNotice: false,
      yaoqingNum: 0,
      yaoqing: false,
      dialogVisible: false,
      showLingqu: false,
      answerNum:0,
      aId:0, //编辑回答

      upViewParam:{
        id:0,
        hits:0,//浏览量
        // comment:0,//回答数
      },
      aboutParam:{
        id:0,
        pageIndex: 1,
        pageSize: 4,
        publishStatus:1, //已发布
        deleteFlag: 0,  //正常
        ruleIsUseful:1,
        getType:"about",
      },
      aboutList:[],
      aboutTotal:0,

      friendList:[],
      friendTotal:0,
      friend:{
        pageIndex: 1,
        pageSize: 5,
      },
      recommendList:[],
      recommendTotal:0,
      recommendParam: {
        pageIndex:1,
        pageSize:5,
      },
      shareUserParam:{
        objectType:8,
        objectId:0, //问题ID
        shareTo:7, //；7为好友邀请；8为推荐邀请；
      },
      shareFriendList:[],
      shareCommendList:[],
      isExistAttention:false,
      attentionCount: 0, //关注数

      isReloadWanfa: false,
      callbackurl:'',
      disLikeCount:0,
      likeCount:0,
      likeFlag:false,
      disLikeFlag:false,
    }
  },
  computed: {
    ...mapState(["questionDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    let id = this.$route.query.id
    if(id){
      this.objId =parseInt(id)
    }
    return this.fetchData();

  },
  // destroyed() {
  //   this.$store.commit("SET_QUESTION_DETAIL", { detail: null });
  // },
  beforeMount(){
    // 只会在浏览器执行
    this.$options.components.quePinglun = () =>import('../pub/quepinglun');
  },
  mounted () {
    this.showNoticeEvent()

    const alreadyIncremented = !!this.questionDetail
    if (!alreadyIncremented) {
      this.fetchData().then(
              setTimeout(()=> {
                this.initData()
              },1500)
      );
    } else {
      setTimeout(()=> {
        this.initData()
      },1500)
    }
  },
  methods: {
    //关注
    doExistAttention(){
      if(this.global.isLogin){
        const formData = new FormData() // 创建form对象
        formData.append('userId', this.loginUserId)
        formData.append('objectId', this.objId)

        contentattentionApi.addAttention(formData).then(re =>{

          this.isExistAttention = true
          this.attentionCount +=1
        })
      }else{
        this.$message.error("未登录")
        return false
      }
    },

    setSeo() {
      this.headTitle = this.questionDetail.title+"——人人动画网【官网】";
      let selTag =  JSON.parse(this.questionDetail.questionTags)
      let keys = ''
      selTag.forEach(item =>{
        keys += item.tag+","
      })
      this.headKeywords = keys;
      let desc = this.questionDetail.content.replace(/<\/?.+?>/g,"").trim()
      this.headDesc =desc.substr(0,150);
    },
    fetchData(){
      this.$loading(true)
      const cookies = this.$ssrContext && this.$ssrContext.cookies
      return this.$store
              .dispatch("FETCH_QUESTION_DETAIL", {
                id: this.$route.query.id
              })
              .finally(() => {
                this.$loading(false);
                this.setSeo()
                updateTdk.call(this);
              });
    },

    initData(){
      let thiss = this

      thiss.question  = thiss.questionDetail
      thiss.objId =parseInt(thiss.question.id)


      if(thiss.question.accept !=0){
        //最佳答主
        thiss.getAcceptUser()
      }

      //增加访问量
      thiss.upViewParam.id = this.question.id
      thiss.upViewParam.hits = this.question.hits + 1
      questionApi.update(thiss.upViewParam).then(re =>{
        //console.log("re---",re.response.hits)
      })

      //回答编辑
      let aId=  this.$route.query.aId
      if(aId){
        this.aId = aId
        // this.reLoadTick()
      }

      if(thiss.global.isLogin){
        thiss.loginUserId = thiss.global.userModel.id
        thiss.isLogin = true

        //登录用户是否关注问题
        const formData = new FormData() // 创建form对象
        formData.append('userId', this.loginUserId)
        formData.append('objectId', this.objId)
        contentattentionApi.existAttention(formData).then( reExist =>{
          if(reExist.response){
            this.isExistAttention = true
          }
        })
        thiss.isShow = true
        thiss.isMounted = true;
      }else{
        thiss.isShow = true
        thiss.isMounted = true;
      }

      thiss.about()

      thiss.isReload = true

      //关注数量
      const formData = new FormData() // 创建form对象
      formData.append('objectId', this.objId)
      contentattentionApi.getCountByObjId(formData).then( reExist =>{
        if(reExist.code == 1){
          this.attentionCount = reExist.response
        }
      })

      let url = '/rrbi/question/getTricks?&ti=' + new Date().getMilliseconds();
      this.$axios.get(url).then(re=>{
        if(re.data.code == 1){
          let reData = re.data.response
          this.likeCount = reData.likeCount
          this.disLikeCount = reData.disLikeCount
          this.disLikeFlag = reData.disLikeFlag
          this.likeFlag = reData.likeFlag

          this.reLoadWanfaTick()
        }
      })
    },
    setAnswerNum(number){
      this.answerNum = number
    },
    //获取最佳答主信息
    getAcceptUser(){
      let thiss = this
      answerApi.selectByAcceptID(thiss.question.accept).then( data =>{
        thiss.userInfo = data.response

        thiss.getFriendStatus()
      })
    },
    about(){
      let this_ = this
      this_.aboutParam.id =this_.question.id
      questionApi.getPage(this_.aboutParam).then(reAbout => {
        this_.aboutList= reAbout.list
        this_.aboutTotal= reAbout.total
        if(this_.aboutParam.pageIndex == Math.ceil(this_.aboutTotal/this_.aboutParam.pageSize) ){
          this_.aboutParam.pageIndex =1
        }else{

          this_.aboutParam.pageIndex = this_.aboutParam.pageIndex+1
        }
      })
    },
    //重置组建
    reLoadTick(){
      let thiss = this
      thiss.isReload = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      thiss.$nextTick(() => {
        thiss.isReload = true
      })
    },

    //重置组建
    reLoadWanfaTick(){
      let thiss = this
      thiss.isReloadWanfa = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      thiss.$nextTick(() => {
        thiss.isReloadWanfa = true
      })
    },

    doFollow(userId){
      let this_ = this
      homeApi.follower(userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status >= 1) {
          this_.userInfo.followStatus=status
          this_.$message.success("关注成功")
        } else {
          this_.$message.error("关注失败")
        }
      })
    },
    undoFollower(userId) {
      let _this = this;
      homeApi.undoFollower(userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status == 1) {
          _this.userInfo.followStatus=0
          _this.$message.success("取消成功")
        } else {
          _this.$message.error("取消失败")
        }
      })
    },

    getFriendStatus(){
      let _this=this;
      let url="/rrbi/friends/getFriendStatus?userId="+_this.userInfo.userId+"&currentUserId="+_this.loginUserId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        console.log("result",result.data)
        _this.friendStatus = result.data
      })
    },
    addFriend() {
      let _this = this;
      if (_this.global.isLogin) {
        let url = '/rrbi/friends/add/' + _this.question.userId + "?ti=" + new Date().getMilliseconds();
        _this.$axios.get(url).then(function (result) {
          // console.log(result)
          if (result.data.response.code == 1) {
            _this.$message.success(result.data.response.msg)
            _this.friendStatus = 1
          } else {
            _this.$message.error(result.data.response.msg)
          }
        })
      }
    },


    searchFriends(page){
      let _this = this;
      if (_this.isLogin) {
        _this.friend.pageIndex = page;
        let url = '/rrbi/friends/list?status=2&pageIndex=' + _this.friend.pageIndex + '&pageSize=' + _this.friend.pageSize + "&ti=" + new Date().getMilliseconds();
        _this.$axios.get(url).then(function (result) {
          //console.log(result)
          _this.friendList = result.data.response.list
          _this.friendTotal = result.data.response.total
        })
      }
    },

    searchRecommend(page){
      let thiss = this
      thiss.recommendParam.pageIndex = page
      userInfoApi.getPage(thiss.recommendParam).then(reUser => {
        console.log("reUser===",reUser)
        thiss.recommendList =reUser.list
        thiss.recommendTotal = reUser.total
        thiss.recommendParam.pageIndex = reUser.pageNum
      });
    },


    // 邀请 ----好友、推荐选择
    yaoqingSelect (num) {
      this.yaoqingNum = num
      if(num == 1){
        this.shareUserParam.shareTo = 8
        if(this.shareCommendList.length == 0 ){
          shareApi.getShareList(this.shareUserParam).then( re => {
            this.shareCommendList = re.response
            this.searchRecommend(1)
          })
        }else{
          this.searchRecommend(1)
        }

      }else{
        this.searchFriends(1)
      }
    },

    //邀请回答
    yaoqingEvent () {

      if(!this.global.isLogin){
        this.$message.error("未登录");
        return false
      }
      this.yaoqing = true

      let thiss = this
      thiss.shareUserParam.objectId = thiss.objId
      //查询当前已经邀请的
      if(thiss.shareFriendList.length == 0 ){
        thiss.shareUserParam.shareTo = 7
        shareApi.getShareList(thiss.shareUserParam).then( re => {
          thiss.shareFriendList = re.response
          thiss.searchFriends(1)
        })
      }else{
        thiss.searchFriends(1)
      }
    },

    doShare(type,uId,belongSection){
      if(type == 1){
        apiService.doshare2({"userId":uId,"objectType":8, "objectId": this.objId,"belongSection":belongSection,"shareTo":7,"time": new Date().getMilliseconds()}).then(data => {
          this.$message.success("成功!");
          this.shareFriendList.push(uId)
        })
      }else{
        if(this.shareCommendList.length >=5){
          this.$message.error("推荐邀请最多邀请5个!");
          return false
        }
        apiService.doshare2({"userId":uId,"objectType":8, "objectId": this.objId,"belongSection":belongSection,"shareTo":8,"time": new Date().getMilliseconds()}).then(data => {
          this.$message.success("成功!");
          this.shareCommendList.push(uId)
        })
      }
    },
    tianjiaEvent () {
      if(this.global.isLogin){
        this.$refs.pinglun.showEdit()
        this.toTop()
      }else {
        this.$message.error("未登录");
        return false
      }

    },
    wanfaEvent () {
      this.dialogVisible = true
    },
    //领取最佳答主悬赏
    lingqu () {
      answerApi.doReceive(this.question.id).then(re =>{
        if(re.code == 1){
          console.log("re.response    ",re.response)
          if(re.response == 1){
            this.showLingqu = true
            this.userInfo.isReceive =1
          }else if(re.response == -1){
            this.$message.error("订单(订单详情)信息获取失败，请联系管理员");
          }else if(re.response == -2){
            this.$message.error("问题信息获取失败，请联系管理员");
          }else if(re.response == -3){
            this.$message.error("答案信息获取失败，请联系管理员");
          }else if(re.response == -4){
            this.$message.error("个人钱包信息获取失败，请联系管理员");
          }

        }else{
          this.$message.error("领取失败，请联系管理员");
        }
      })
    },
    closeLingqu () {
      this.showLingqu = false
    },
    showNoticeEvent () {
      this.showNotice = true
      this.timeoutNotice = setTimeout(() => {
        this.showNotice = false
      }, 5000)
    },
    closeNotice () {
      this.showNotice = false
    },
    toTop(){
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeoutNotice)
  }
}
</script>

<style scoped lang="less">
// .page-question .left-right-content{
//   margin-top: 30px;
// }
.lingqu-jiangli{
  position: fixed;
  z-index: 1889;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .3);
  .wrap{
    .close-icon{
      position: absolute;
      right: -10px;
      top: -10px;
      color: #fff;
      font-size: 25px;
      cursor: pointer;
    }
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -105px 0 0 -150px;
    width: 300px;
    height: 205px;
    text-align: center;
    background-image: url('../../../assets/images/xs_get_bg.png');
    background-size: 100% 100%;
    .words{
      position: absolute;
      top: 32px;
      width: 100%;
      font-size: 14px;
      color: #d5362b;
    }
    .money{
      position: absolute;
      top: 60px;
      width: 100%;
      text-align: center;
      color: #f3574a;
      font-size: 54px;
      font-weight: bold;
    }
    .chakan{
      // 510 * 348
      position: absolute;
      bottom: 15px;
      left: 50%;
      margin-left: -40px;
      width: 80px;
      color: #930c05;
      font-size: 16px;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter,
.fade-leave-to{
  opacity: 0;
}
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
</style>
